import Cookies from 'universal-cookie';
import { push } from 'react-router-redux';

import api from '../../api/index.js';
import actions from './actions.js';
import { toSubmissionError } from '~/utils/transform.js';

import mapping from '~/utils/mapping.json';


const cookies = new Cookies();

const getClientID = (product_id) => {
    if (product_id === mapping.license.by_name.NOBLEHOUR) {
        return process.env.CLIENT_ID_NH;

    } else if (product_id === mapping.license.by_name.COLLABORATORY) {
        return process.env.CLIENT_ID_COL;
    }
    return null;
};

/*
 * redux-form onSubmit function, called by handleSubmit
 */
export async function login(values, dispatch) {

    cookies.remove('auth');

    const {
        username, password, product_id, api_url,
    } = values.toJS();

    const baseURL = api_url;
    const client_id = getClientID(product_id);
    const client_secret = process.env.CLIENT_SECRET;

    try {
        const res = await dispatch(api.post('/oauth/token', {
            baseURL,
            params: null,
            data: {
                grant_type: 'password',
                client_id,
                client_secret,
                username,
                password,
            },
            auth: {
                username: client_id,
                password: client_secret,
            },
        }));

        const {
            data: {
                access_token,
                expires_in,
                user,
            },
        } = res;

        // Validate user's role before saving auth data
        const roles = await dispatch(api.get(`/users/${user.id}/role`, {
            baseURL,
            params: { access_token },
        }));

        const { data: { role_id } } = roles;

        if (role_id !== mapping.roles.by_name.ADMINISTRATOR) {
            const role_name = mapping.roles.by_id[role_id.toString()];

            throw new Error(`Account must be a site-admin Administrator. Found ${role_name} role`);
        }

        const auth = {
            baseURL,
            access_token,
            user,
            product_id,
        };

        cookies.set('auth', JSON.stringify(auth), {
            path: '/',
            maxAge: expires_in,
        });

        dispatch(actions.login(auth));
        dispatch(push('/'));

    } catch (error) {
        dispatch(actions.logout());
        throw toSubmissionError(error);

    }
}


/*
 * redux action creator
 */
export const logout = () => (dispatch) => {
    cookies.remove('auth');

    dispatch(actions.logout());
    dispatch(push('/login'));
};

